import React from 'react';
import { Box, Text, SimpleGrid, Card, HStack, Button, VStack, NativeSelect, Flex } from '@chakra-ui/react';
import StatCard from '../../../components/utils/StatCard';
import { FaLayerGroup, FaMapMarkedAlt, FaCampground, FaBookOpen } from "react-icons/fa";

const ControlTile = ({ title, status, statusColor, options = [], ctaLabel }) => (
  <VStack align="stretch" gap="3" w="full">
    <HStack>
      <Button aria-label={status} bg={statusColor} />
      <Box>
        <Text fontWeight="semibold">{title}</Text>
        <Text fontSize="sm" fontWeight="light">{status}</Text>
      </Box>
    </HStack>

    <Box>
      <Text fontWeight="semibold" mb="1">{title}</Text>
      <NativeSelect.Root w="full">
        <NativeSelect.Field w="full">
          {options.map(o => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </NativeSelect.Field>
        <NativeSelect.Indicator />
      </NativeSelect.Root>
    </Box>

    <Button w="full">{ctaLabel}</Button>
  </VStack>
);

const Club = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">Ajustes del Club</Text>
      <Text pb="5">Configura los ajustes del Club</Text>
      <SimpleGrid pb="5" columns={[2, 4]} gap="2">
        <StatCard title="Semestres" data="7" icon={FaBookOpen} tone="info" />
        <StatCard title="Camps" data="3" icon={FaCampground } tone="success" />
        <StatCard title="Niveles" data="9" icon={FaLayerGroup} tone="warning" />
        <StatCard title="Campuses" data="3" icon={FaMapMarkedAlt} tone="danger" />
      </SimpleGrid>

      <SimpleGrid columns={[1, 4]} gap="2">
        <Card.Root size="sm" height="auto" bg="dashboard.bg.surface">
          <Card.Header>
            <Text fontSize="lg" fontWeight="bold">Control Central</Text>
          </Card.Header>
          <Card.Body>
            <Text fontWeight="semibold" pb="2">Registro</Text>
            <Box>
              <SimpleGrid columns="2" gap="2">
                <ControlTile
                  title="Semestre"
                  status="Activado"
                  statusColor="green.500"
                  options={[{ value: "AD2025", label: "AD2025" }]}
                  ctaLabel="Nuevo Semestre"
                />
                <ControlTile
                  title="Camp"
                  status="Desactivado"
                  statusColor="red.500"
                  options={[{ value: "2024", label: "2024" }]}
                  ctaLabel="Nuevo Camp"
                />
              </SimpleGrid>
            </Box>
          </Card.Body>
        </Card.Root>

        <Card.Root size="sm" height="auto" bg="dashboard.bg.surface">
          <Card.Header>
            <Text fontSize="lg" fontWeight="bold">Niveles</Text>
          </Card.Header>
          <Card.Body>
            <Box pb="5">
              <Text fontWeight="semibold" pb="2">Monterrey</Text>
              <SimpleGrid columns="2" gap="2">
                <HStack>
                  <Box w="24px" h="24px" bg="green.400" borderRadius="sm" />
                  <Text>4° Grado</Text>
                </HStack>
                <HStack>
                  <Box w="24px" h="24px" bg="orange.400" borderRadius="sm" />
                  <Text>5° Grado</Text>
                </HStack>
                <HStack>
                  <Box w="24px" h="24px" bg="yellow.400" borderRadius="sm" />
                  <Text>6° Grado</Text>
                </HStack>
                <HStack>
                  <Box w="24px" h="24px" bg="red.400" borderRadius="sm" />
                  <Text>7° Grado</Text>
                </HStack>
                <HStack>
                  <Box w="24px" h="24px" bg="blue.400" borderRadius="sm" />
                  <Text>8° Grado</Text>
                </HStack>
                <HStack>
                  <Box w="24px" h="24px" bg="purple.400" borderRadius="sm" />
                  <Text>9° Grado</Text>
                </HStack>
              </SimpleGrid>
            </Box>
            <Box pb="5">
              <Text fontWeight="semibold" pb="2">Saltillo</Text>
              <SimpleGrid columns="2" gap="2">
                <HStack>
                  <Box w="24px" h="24px" bg="teal.400" borderRadius="sm" />
                  <Text>4° a 6°</Text>
                </HStack>
                <HStack>
                  <Box w="24px" h="24px" bg="pink.400" borderRadius="sm" />
                  <Text>7° y 8°</Text>
                </HStack>
              </SimpleGrid>
            </Box>
            <Box pb="5">
              <Text fontWeight="semibold" pb="2">Lince</Text>
              <SimpleGrid columns="2" gap="2">
                <HStack>
                  <Box w="24px" h="24px" bg="cyan.400" borderRadius="sm" />
                  <Text>Lince</Text>
                </HStack>
              </SimpleGrid>
            </Box>
          </Card.Body>
        </Card.Root>

        <Card.Root size="sm" height="auto" bg="dashboard.bg.surface">
          <Card.Header>
            <Text fontSize="lg" fontWeight="bold">Campuses</Text>
          </Card.Header>
          <Card.Body>
            <Flex w="full" h="50px" align="center" justify="center" bg="red.200" rounded="md" mb="2">
              <Text fontWeight="bold">Monterrey</Text>
            </Flex>
            <Flex w="full" h="50px" align="center" justify="center" bg="green.200" rounded="md" mb="2">
              <Text fontWeight="bold">Saltillo</Text>
            </Flex>
            <Flex w="full" h="50px" align="center" justify="center" bg="blue.200" rounded="md" mb="2">
              <Text fontWeight="bold">Lince</Text>
            </Flex>
            <Flex w="full" h="50px" align="center" justify="center" bg="orange.200" rounded="md">
              <Text fontWeight="bold">[ + ]</Text>
            </Flex>
          </Card.Body>
        </Card.Root>

      </SimpleGrid>
    </Box>
  );
};

export default Club;
